import { render, staticRenderFns } from "./PersonalizationMicrosoftStep2.vue?vue&type=template&id=99311d52&scoped=true"
import script from "./PersonalizationMicrosoftStep2.vue?vue&type=script&lang=js"
export * from "./PersonalizationMicrosoftStep2.vue?vue&type=script&lang=js"
import style0 from "./PersonalizationMicrosoftStep2.vue?vue&type=style&index=0&id=99311d52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99311d52",
  null
  
)

export default component.exports